export default (state = {
    projects: []
}, action) => {
    switch (action.type) {
        case "AddProject":
            state = { ...state,
                projects: action.projects
            };
            break;
        default:
            return state;
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/Reducers/projects.js